// extracted by mini-css-extract-plugin
export default {"white_Space":"WhiteSpace2_white_Space__DiF8p"};